<template>
  <div
    class="quincy-wrapper__controls__erase-button"
    @click="toggleActionStates"
    :class="activeClass"
    v-tippy="{ placement: 'right', content: $t('components.quincy.buttons.erase') }"
    data-cy="quincy-controls-erase"
  >
    <erase-vue :selected="eraseActive"></erase-vue>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import { GETTERS, MUTATIONS } from '../../store/quincy/definitions';
import EraseVue from './controls/Erase.vue';

export default {
  components: {
    EraseVue
  },
  methods: {
    ...mapMutations('quincy', {
      $TOGGLECONTROLS: MUTATIONS.TOGGLE_CONTROLS
    }),
    toggleActionStates() {
      this.$TOGGLECONTROLS({ erase: !this.eraseActive });
    }
  },
  computed: {
    ...mapGetters('quincy', {
      $SETTINGS: GETTERS.SETTINGS
    }),
    eraseActive() {
      return this.$SETTINGS.controls.erase;
    },
    activeClass() {
      return this.eraseActive !== true
        ? ''
        : 'quincy-wrapper__controls__erase-button--active';
    }
  }
};
</script>

<style lang="css"></style>
